import styled, { css } from 'styled-components';

import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';
import { GhostButton } from 'components/Toolkit/Button/GhostButton';
import { StatusBar } from 'components/Toolkit/StatusBar/StatusBar';
import { Menu } from 'components/Toolkit/Menu/Menu';
import { BaseModal } from 'components/Toolkit/Modal/BaseModal';

import { media } from 'helpers/breakpoints';
import { theme } from 'helpers/Theme/';

export const Header = styled(InfoTitle)`
  display: block;
  /* Use the full width available for the title less the close modal x width */
  width: calc(100% - ${({ theme }) => theme.spacing.M32});
  ${media.large} {
    padding: 0;
  }
`;

export const PlaceHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  ${({ theme }) => theme.fontSize.M16}
  height: 180px;
  background-color: ${({ theme }) => theme.colors.GREY_LIGHTER};

  ${media.medium} {
    height: 301px;
  }
`;

export const ChartContainer = styled.div`
  position: relative;
  height: 180px;

  ${media.medium} {
    height: 301px;
  }
`;

export const SStatusBar = styled(StatusBar)`
  margin-bottom: ${({ theme }) => theme.spacing.M16};
  padding: 0;
`;

export const ManageButton = styled(GhostButton)`
  box-shadow: none;
  color: ${({ theme }) => theme.colors.GREY_DARK};

  &:hover:after {
    display: none;
  }
`;

export const SMenu = styled(Menu)`
  width: 188px;
`;

export const SBaseModal = styled(BaseModal)`
  ${media.smallOnly} {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9950;
    width: 100%;
    border-radius: ${({ theme }) =>
      `${theme.borderRadius.large} ${theme.borderRadius.large} 0 0`};
    transform: translateY(100%);
    transition: all 0.4s ease-in-out;

    .ReactModal__Overlay--after-open & {
      transform: translateY(0);
    }

    .ReactModal__Overlay--before-close & {
      transform: translateY(100%);
    }

    :focus {
      outline: none;
    }
  }

  @media screen and (orientation: landscape) {
    height: 100%;
  }

  ${media.medium} {
    width: 768px;
    padding: ${({ theme }) => theme.spacing.L48};
  }
`;

export const SSpan = styled.span`
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;

export const closeButtonCSS = css`
  ${media.medium} {
    top: ${theme.spacing.L48};
    right: ${theme.spacing.L48};
  }
`;
